
import { useState } from 'react';

const HeroSection = () => {
  const [backgroundImage] = useState('https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/fe67df12de662aebbd1e997548fb5355.jpeg');

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${backgroundImage}')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            專業<strong>噴砂噴漆</strong>工程
            <br />
            守護您的建築與設備安全
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto leading-relaxed">
            錏設工程行成立於2016年，擁有30年實務經驗，專注工業及公共工程的<strong>噴砂噴漆服務</strong>，
            提供金屬表面除鏽、防鏽處理與高品質粉刷，品質第一、客戶滿意。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="mailto:yashe4853@gmail.com"
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              立即諮詢報價
            </a>
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              線上客服諮詢
            </button>
          </div>
          
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold text-teal-400 mb-2">30+</div>
              <div className="text-lg">年實務經驗</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold text-teal-400 mb-2">100+</div>
              <div className="text-lg">完成專案</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold text-teal-400 mb-2">24/7</div>
              <div className="text-lg">專業服務</div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
